import { ReactNode } from 'react';
import { EndReasonTypeDataProvider } from '../contexts/EndReasonTypeDataContext';
import { FafsaDataProvider } from '../contexts';
import { CardId } from '../types';

interface DashboardDataProvidersProps {
    children: ReactNode;
    visibleCardIds: CardId[];
}

/**
 * Providers are only mounted when at least one of their dependent cards is visible,
 * Cards that are self-contained: (Notifications, TotalStudents, SchoolEnrollment)
 * maintain their own internal providers.
 */
export const DashboardDataProviders = ({ children, visibleCardIds }: DashboardDataProvidersProps) => {
    const needsFafsa = visibleCardIds.some((id) => id.startsWith('fafsa-'));
    const needsEndReason = visibleCardIds.some((id) => id.startsWith('end-reason-type-'));

    let wrapped = children;

    if (needsFafsa) {
        wrapped = <FafsaDataProvider>{wrapped}</FafsaDataProvider>;
    }

    if (needsEndReason) {
        wrapped = <EndReasonTypeDataProvider>{wrapped}</EndReasonTypeDataProvider>;
    }

    return <>{wrapped}</>;
};